import type {
  ReactionListItem,
  ReactionDetail,
  ReactionParticipant,
  ImportItemDetail,
} from '../types/reactions';

// ── List items (hub page) ──────────────────────────────────────────────

export const mockReactionsList: ReactionListItem[] = [
  {
    id: 1,
    reaction_smiles: 'CC(=O)O.CCO>>CC(=O)OCC',
    rxnfile_available: true,
    source: 'MANUAL_UPLOAD',
    source_ref: 'fischer-esterification-01',
    created_at: '2025-12-10T14:23:00Z',
    file: { id: 10, name: 'fischer_reactions.rxn' },
    conditions: {
      solvents: ['Toluene'],
      catalysts: ['H2SO4'],
      temperature_c: 110,
      time_h: 4,
    },
    outcome: { yield_percent: 87, yield_type: 'isolated' },
    counts: { reactants: 2, products: 1, catalysts: 1 },
    enrichment_rollup: {
      matched_participants: 3,
      total_participants: 3,
      matched_products: 1,
      total_products: 1,
      patent_collisions: { total: 0, by_zone: {} },
      knowledge_centre: { in_surechembl_products: 1, in_chembl_products: 1, in_pubchem_products: 1 },
      biology: { targets: 2, pathways: 1 },
    },
    reaction_type: null,
    thumbnail: { kind: 'placeholder', url: '' },
  },
  {
    id: 2,
    reaction_smiles: 'c1ccccc1Br.OB(O)c1ccc(C)cc1>>c1ccccc1-c1ccc(C)cc1',
    rxnfile_available: true,
    source: 'ORD',
    source_ref: 'ord-suzuki-2024-0042',
    created_at: '2025-11-28T09:15:00Z',
    file: { id: 11, name: 'suzuki_coupling_set.rdf' },
    conditions: {
      solvents: ['DMF', 'Water'],
      catalysts: ['Pd(PPh3)4'],
      temperature_c: 80,
      time_h: 12,
    },
    outcome: { yield_percent: 92, yield_type: 'isolated' },
    counts: { reactants: 2, products: 1, catalysts: 1 },
    enrichment_rollup: {
      matched_participants: 2,
      total_participants: 3,
      matched_products: 1,
      total_products: 1,
      patent_collisions: {
        total: 3,
        by_zone: { 'US': 2, 'EP': 1 },
      },
      knowledge_centre: { in_surechembl_products: 1, in_chembl_products: 0, in_pubchem_products: 1 },
      biology: { targets: 0, pathways: 0 },
    },
    reaction_type: null,
    thumbnail: { kind: 'placeholder', url: '' },
  },
  {
    id: 3,
    reaction_smiles: 'CC(C)C=O.[NH3]>>CC(C)C=N',
    rxnfile_available: false,
    source: 'MANUAL_UPLOAD',
    source_ref: null,
    created_at: '2026-01-05T16:40:00Z',
    file: { id: 12, name: 'imine_formation.sdf' },
    conditions: {
      solvents: ['MeOH'],
      catalysts: null,
      temperature_c: 25,
      time_h: 2,
    },
    outcome: { yield_percent: 65, yield_type: 'crude' },
    counts: { reactants: 2, products: 1, catalysts: 0 },
    enrichment_rollup: {
      matched_participants: 3,
      total_participants: 3,
      matched_products: 1,
      total_products: 1,
      patent_collisions: { total: 0, by_zone: {} },
      knowledge_centre: { in_surechembl_products: 0, in_chembl_products: 0, in_pubchem_products: 1 },
      biology: { targets: 0, pathways: 0 },
    },
    reaction_type: null,
    thumbnail: { kind: 'placeholder', url: '' },
  },
  {
    id: 4,
    reaction_smiles: 'c1ccc2[nH]ccc2c1.ClC(=O)CCl>>c1ccc2c(c1)cc(CC(=O)Cl)[nH]2',
    rxnfile_available: true,
    source: 'SURF',
    source_ref: 'SURF-2025-1188',
    created_at: '2026-01-20T11:00:00Z',
    file: { id: 13, name: 'friedel_crafts.rxn' },
    conditions: {
      solvents: ['DCM'],
      catalysts: ['AlCl3'],
      temperature_c: 0,
      time_h: 1,
    },
    outcome: { yield_percent: 45, yield_type: 'isolated' },
    counts: { reactants: 2, products: 1, catalysts: 1 },
    enrichment_rollup: {
      matched_participants: 1,
      total_participants: 3,
      matched_products: 0,
      total_products: 1,
      patent_collisions: {
        total: 7,
        by_zone: { 'US': 3, 'EP': 2, 'JP': 2 },
      },
      knowledge_centre: { in_surechembl_products: 1, in_chembl_products: 1, in_pubchem_products: 0 },
      biology: { targets: 5, pathways: 2 },
    },
    reaction_type: null,
    thumbnail: { kind: 'placeholder', url: '' },
  },
  {
    id: 5,
    reaction_smiles: null,
    rxnfile_available: false,
    source: 'MANUAL_UPLOAD',
    source_ref: null,
    created_at: '2026-02-01T08:30:00Z',
    file: { id: 14, name: 'unknown_rxn.rxn' },
    conditions: {
      solvents: null,
      catalysts: null,
      temperature_c: null,
      time_h: null,
    },
    outcome: { yield_percent: null, yield_type: null },
    counts: { reactants: 0, products: 0, catalysts: 0 },
    enrichment_rollup: {
      matched_participants: 0,
      total_participants: 0,
      matched_products: 0,
      total_products: 0,
      patent_collisions: { total: 0, by_zone: {} },
      knowledge_centre: { in_surechembl_products: 0, in_chembl_products: 0, in_pubchem_products: 0 },
      biology: { targets: 0, pathways: 0 },
    },
    reaction_type: null,
    thumbnail: { kind: 'placeholder', url: '' },
  },
];

// ── Participants for detail mock ──────────────────────────────────────

const fischerParticipants: ReactionParticipant[] = [
  {
    id: 101,
    role: 'REACTANT',
    component_no: 0,
    structure: { smiles: 'CC(=O)O', inchi_key: 'QTBSBXVTEAMEQO-UHFFFAOYSA-N' },
    user_molecule: { molecule_id: 501, file_id: 10, mol_index: 0, match_confidence: 0.99 },
    enrichment: {
      knowledge_centre: {
        surechembl: { present: true, ids: ['SCHEMBL1'] },
        chembl: { present: true, chembl_id: 'CHEMBL539' },
        pubchem: { present: true, cid: 176 },
      },
      patents: { zone: null, count: null },
      biology: { targets: [], pathways: [] },
    },
  },
  {
    id: 102,
    role: 'REACTANT',
    component_no: 1,
    structure: { smiles: 'CCO', inchi_key: 'LFQSCWFLJHTTHZ-UHFFFAOYSA-N' },
    user_molecule: { molecule_id: 502, file_id: 10, mol_index: 1, match_confidence: 1.0 },
    enrichment: {
      knowledge_centre: {
        surechembl: { present: true, ids: ['SCHEMBL2'] },
        chembl: { present: true, chembl_id: 'CHEMBL545' },
        pubchem: { present: true, cid: 702 },
      },
      patents: { zone: null, count: null },
      biology: { targets: [], pathways: [] },
    },
  },
  {
    id: 103,
    role: 'PRODUCT',
    component_no: 0,
    structure: { smiles: 'CC(=O)OCC', inchi_key: 'XEKOWRVHYACXOJ-UHFFFAOYSA-N' },
    user_molecule: { molecule_id: 503, file_id: 10, mol_index: 2, match_confidence: 0.97 },
    enrichment: {
      knowledge_centre: {
        surechembl: { present: true, ids: ['SCHEMBL3'] },
        chembl: { present: true, chembl_id: 'CHEMBL553' },
        pubchem: { present: true, cid: 8857 },
      },
      patents: { zone: null, count: null },
      biology: { targets: [{ id: 'T1' }], pathways: [{ id: 'P1' }] },
    },
  },
  {
    id: 104,
    role: 'CATALYST',
    component_no: 0,
    structure: { smiles: 'OS(=O)(=O)O', inchi_key: 'QAOWNCQODCNURD-UHFFFAOYSA-N' },
    user_molecule: { molecule_id: null, file_id: null, mol_index: null, match_confidence: null },
    enrichment: {
      knowledge_centre: {
        surechembl: { present: null, ids: null },
        chembl: { present: null, chembl_id: null },
        pubchem: { present: null, cid: null },
      },
      patents: { zone: null, count: null },
      biology: { targets: [], pathways: [] },
    },
  },
];

// ── Detail mocks (keyed by id) ────────────────────────────────────────

export const mockReactionDetails: Record<number, ReactionDetail> = {
  1: {
    id: 1,
    projectId: 1,
    tenantId: 1,
    source: 'MANUAL_UPLOAD',
    source_ref: 'fischer-esterification-01',
    file: { id: 10, name: 'fischer_reactions.rxn', import_job_id: 100, source_row: 1 },
    reaction: {
      reaction_smiles: 'CC(=O)O.CCO>>CC(=O)OCC',
      atom_mapped_smiles: '[CH3:1][C:2](=[O:3])[OH:4].[CH3:5][CH2:6][OH:7]>>[CH3:1][C:2](=[O:3])[O:4][CH2:6][CH3:5]',
      rxnfile: null,
      notes: 'Classic Fischer esterification with H2SO4 catalyst',
    },
    conditions: {
      solvents: ['Toluene'],
      reagents_text: null,
      catalysts: ['H2SO4'],
      temperature_c: 110,
      time_h: 4,
      pressure_bar: null,
      ph: null,
      atmosphere: null,
    },
    outcome: { yield_percent: 87, yield_type: 'isolated' },
    participants: fischerParticipants,
    enrichment_rollup: {
      matched_participants: 3,
      total_participants: 3,
      patent_collisions_total: 0,
      targets_total: 2,
      pathways_total: 1,
    },
    reaction_type: null,
    created_at: '2025-12-10T14:23:00Z',
    updated_at: '2025-12-10T14:23:00Z',
  },
  2: {
    id: 2,
    projectId: 1,
    tenantId: 1,
    source: 'ORD',
    source_ref: 'ord-suzuki-2024-0042',
    file: { id: 11, name: 'suzuki_coupling_set.rdf', import_job_id: 101, source_row: 42 },
    reaction: {
      reaction_smiles: 'c1ccccc1Br.OB(O)c1ccc(C)cc1>>c1ccccc1-c1ccc(C)cc1',
      atom_mapped_smiles: null,
      rxnfile: null,
      notes: 'Suzuki coupling from ORD dataset',
    },
    conditions: {
      solvents: ['DMF', 'Water'],
      reagents_text: ['K2CO3'],
      catalysts: ['Pd(PPh3)4'],
      temperature_c: 80,
      time_h: 12,
      pressure_bar: null,
      ph: null,
      atmosphere: 'N2',
    },
    outcome: { yield_percent: 92, yield_type: 'isolated' },
    participants: [
      {
        id: 201, role: 'REACTANT', component_no: 0,
        structure: { smiles: 'c1ccccc1Br', inchi_key: 'QARVLSVVCXYDNA-UHFFFAOYSA-N' },
        user_molecule: { molecule_id: 601, file_id: 11, mol_index: 0, match_confidence: 0.95 },
        enrichment: {
          knowledge_centre: {
            surechembl: { present: true, ids: ['SCHEMBL10'] },
            chembl: { present: false, chembl_id: null },
            pubchem: { present: true, cid: 7961 },
          },
          patents: { zone: 'US', count: 2 },
          biology: { targets: [], pathways: [] },
        },
      },
      {
        id: 202, role: 'REACTANT', component_no: 1,
        structure: { smiles: 'OB(O)c1ccc(C)cc1', inchi_key: 'FHQDWPCFDJJQHG-UHFFFAOYSA-N' },
        user_molecule: { molecule_id: null, file_id: null, mol_index: null, match_confidence: null },
        enrichment: {
          knowledge_centre: {
            surechembl: { present: true, ids: ['SCHEMBL20'] },
            chembl: { present: null, chembl_id: null },
            pubchem: { present: true, cid: 66765 },
          },
          patents: { zone: 'EP', count: 1 },
          biology: { targets: [], pathways: [] },
        },
      },
      {
        id: 203, role: 'PRODUCT', component_no: 0,
        structure: { smiles: 'Cc1ccc(-c2ccccc2)cc1', inchi_key: 'MVPKIPGHRNIOPT-UHFFFAOYSA-N' },
        user_molecule: { molecule_id: 602, file_id: 11, mol_index: 2, match_confidence: 0.88 },
        enrichment: {
          knowledge_centre: {
            surechembl: { present: true, ids: ['SCHEMBL30'] },
            chembl: { present: false, chembl_id: null },
            pubchem: { present: true, cid: 7095 },
          },
          patents: { zone: 'US', count: 1 },
          biology: { targets: [], pathways: [] },
        },
      },
    ],
    enrichment_rollup: {
      matched_participants: 2,
      total_participants: 3,
      patent_collisions_total: 3,
      targets_total: 0,
      pathways_total: 0,
    },
    reaction_type: null,
    created_at: '2025-11-28T09:15:00Z',
    updated_at: '2025-11-28T09:15:00Z',
  },
  3: {
    id: 3,
    projectId: 1,
    tenantId: 1,
    source: 'MANUAL_UPLOAD',
    source_ref: null,
    file: { id: 12, name: 'imine_formation.sdf', import_job_id: null, source_row: null },
    reaction: {
      reaction_smiles: 'CC(C)C=O.[NH3]>>CC(C)C=N',
      atom_mapped_smiles: null,
      rxnfile: null,
      notes: null,
    },
    conditions: {
      solvents: ['MeOH'],
      reagents_text: null,
      catalysts: null,
      temperature_c: 25,
      time_h: 2,
      pressure_bar: null,
      ph: null,
      atmosphere: null,
    },
    outcome: { yield_percent: 65, yield_type: 'crude' },
    participants: [
      {
        id: 301, role: 'REACTANT', component_no: 0,
        structure: { smiles: 'CC(C)C=O', inchi_key: 'AMQJEAYHLZJPGS-UHFFFAOYSA-N' },
        user_molecule: { molecule_id: 701, file_id: 12, mol_index: 0, match_confidence: 1.0 },
        enrichment: {
          knowledge_centre: {
            surechembl: { present: null, ids: null },
            chembl: { present: null, chembl_id: null },
            pubchem: { present: true, cid: 6564 },
          },
          patents: { zone: null, count: null },
          biology: { targets: [], pathways: [] },
        },
      },
      {
        id: 302, role: 'REACTANT', component_no: 1,
        structure: { smiles: '[NH3]', inchi_key: 'QGZKDVFQNNGYKY-UHFFFAOYSA-N' },
        user_molecule: { molecule_id: 702, file_id: 12, mol_index: 1, match_confidence: 1.0 },
        enrichment: {
          knowledge_centre: {
            surechembl: { present: null, ids: null },
            chembl: { present: null, chembl_id: null },
            pubchem: { present: true, cid: 222 },
          },
          patents: { zone: null, count: null },
          biology: { targets: [], pathways: [] },
        },
      },
      {
        id: 303, role: 'PRODUCT', component_no: 0,
        structure: { smiles: 'CC(C)C=N', inchi_key: null },
        user_molecule: { molecule_id: 703, file_id: 12, mol_index: 2, match_confidence: 0.92 },
        enrichment: {
          knowledge_centre: {
            surechembl: { present: false, ids: null },
            chembl: { present: false, chembl_id: null },
            pubchem: { present: true, cid: 12345 },
          },
          patents: { zone: null, count: null },
          biology: { targets: [], pathways: [] },
        },
      },
    ],
    enrichment_rollup: {
      matched_participants: 3,
      total_participants: 3,
      patent_collisions_total: 0,
      targets_total: 0,
      pathways_total: 0,
    },
    reaction_type: null,
    created_at: '2026-01-05T16:40:00Z',
    updated_at: '2026-01-05T16:40:00Z',
  },
  4: {
    id: 4,
    projectId: 1,
    tenantId: 1,
    source: 'SURF',
    source_ref: 'SURF-2025-1188',
    file: { id: 13, name: 'friedel_crafts.rxn', import_job_id: 102, source_row: 1 },
    reaction: {
      reaction_smiles: 'c1ccc2[nH]ccc2c1.ClC(=O)CCl>>c1ccc2c(c1)cc(CC(=O)Cl)[nH]2',
      atom_mapped_smiles: null,
      rxnfile: null,
      notes: 'Friedel-Crafts acylation on indole scaffold',
    },
    conditions: {
      solvents: ['DCM'],
      reagents_text: null,
      catalysts: ['AlCl3'],
      temperature_c: 0,
      time_h: 1,
      pressure_bar: null,
      ph: null,
      atmosphere: 'Ar',
    },
    outcome: { yield_percent: 45, yield_type: 'isolated' },
    participants: [
      {
        id: 401, role: 'REACTANT', component_no: 0,
        structure: { smiles: 'c1ccc2[nH]ccc2c1', inchi_key: 'SIKJAQJRHWYJAI-UHFFFAOYSA-N' },
        user_molecule: { molecule_id: 801, file_id: 13, mol_index: 0, match_confidence: 0.85 },
        enrichment: {
          knowledge_centre: {
            surechembl: { present: true, ids: ['SCHEMBL40'] },
            chembl: { present: true, chembl_id: 'CHEMBL15844' },
            pubchem: { present: null, cid: null },
          },
          patents: { zone: 'US', count: 3 },
          biology: { targets: [{ id: 'T10' }, { id: 'T11' }], pathways: [{ id: 'P10' }] },
        },
      },
      {
        id: 402, role: 'REACTANT', component_no: 1,
        structure: { smiles: 'ClC(=O)CCl', inchi_key: null },
        user_molecule: { molecule_id: null, file_id: null, mol_index: null, match_confidence: null },
        enrichment: {
          knowledge_centre: {
            surechembl: { present: null, ids: null },
            chembl: { present: null, chembl_id: null },
            pubchem: { present: null, cid: null },
          },
          patents: { zone: 'EP', count: 2 },
          biology: { targets: [], pathways: [] },
        },
      },
      {
        id: 403, role: 'PRODUCT', component_no: 0,
        structure: { smiles: 'c1ccc2c(c1)cc(CC(=O)Cl)[nH]2', inchi_key: null },
        user_molecule: { molecule_id: null, file_id: null, mol_index: null, match_confidence: null },
        enrichment: {
          knowledge_centre: {
            surechembl: { present: true, ids: ['SCHEMBL41'] },
            chembl: { present: true, chembl_id: 'CHEMBL99999' },
            pubchem: { present: false, cid: null },
          },
          patents: { zone: 'JP', count: 2 },
          biology: { targets: [{ id: 'T12' }, { id: 'T13' }, { id: 'T14' }], pathways: [{ id: 'P11' }, { id: 'P12' }] },
        },
      },
    ],
    enrichment_rollup: {
      matched_participants: 1,
      total_participants: 3,
      patent_collisions_total: 7,
      targets_total: 5,
      pathways_total: 2,
    },
    reaction_type: null,
    created_at: '2026-01-20T11:00:00Z',
    updated_at: '2026-01-20T11:00:00Z',
  },
  5: {
    id: 5,
    projectId: 1,
    tenantId: 1,
    source: 'MANUAL_UPLOAD',
    source_ref: null,
    file: { id: 14, name: 'unknown_rxn.rxn', import_job_id: null, source_row: null },
    reaction: {
      reaction_smiles: null,
      atom_mapped_smiles: null,
      rxnfile: null,
      notes: null,
    },
    conditions: {
      solvents: null,
      reagents_text: null,
      catalysts: null,
      temperature_c: null,
      time_h: null,
      pressure_bar: null,
      ph: null,
      atmosphere: null,
    },
    outcome: { yield_percent: null, yield_type: null },
    participants: [],
    enrichment_rollup: {
      matched_participants: 0,
      total_participants: 0,
      patent_collisions_total: 0,
      targets_total: 0,
      pathways_total: 0,
    },
    reaction_type: null,
    created_at: '2026-02-01T08:30:00Z',
    updated_at: '2026-02-01T08:30:00Z',
  },
};

// ── Import preview items ──────────────────────────────────────────────

export const mockImportPreviewItems: ImportItemDetail[] = [
  {
    item_id: 1,
    source_row: 1,
    status: 'VALID',
    preview: { reactants: 2, products: 1, catalysts: 1, hasAtomMapping: true, yieldPercent: 87, solvents: ['Toluene'], tempC: 110, timeH: 4 },
    reaction_smiles: 'CC(=O)O.CCO>>CC(=O)OCC',
    hash: 'abc123',
    atom_mapped_smiles: '[CH3:1][C:2](=[O:3])[OH:4].[CH3:5][CH2:6][OH:7]>>[CH3:1][C:2](=[O:3])[O:4][CH2:6][CH3:5]',
    rxnfile: null,
    conditions: { solvents: ['Toluene'], temperature_c: 110, time_h: 4 },
    outcome: { yield_percent: 87, yield_type: 'isolated' },
    errors: [],
    warnings: [],
  },
  {
    item_id: 2,
    source_row: 2,
    status: 'VALID',
    preview: { reactants: 2, products: 1, catalysts: 1, hasAtomMapping: false, yieldPercent: 92, solvents: ['DMF', 'Water'], tempC: 80, timeH: 12 },
    reaction_smiles: 'c1ccccc1Br.OB(O)c1ccc(C)cc1>>c1ccccc1-c1ccc(C)cc1',
    hash: 'def456',
    atom_mapped_smiles: null,
    rxnfile: null,
    conditions: { solvents: ['DMF', 'Water'], temperature_c: 80, time_h: 12 },
    outcome: { yield_percent: 92, yield_type: 'isolated' },
    errors: [],
    warnings: [],
  },
  {
    item_id: 3,
    source_row: 3,
    status: 'WARNING',
    preview: { reactants: 2, products: 1, catalysts: 0, hasAtomMapping: false, yieldPercent: 65, solvents: ['MeOH'], tempC: 25, timeH: 2 },
    reaction_smiles: 'CC(C)C=O.[NH3]>>CC(C)C=N',
    hash: 'ghi789',
    atom_mapped_smiles: null,
    rxnfile: null,
    conditions: { solvents: ['MeOH'], temperature_c: 25, time_h: 2 },
    outcome: { yield_percent: 65, yield_type: 'crude' },
    errors: [],
    warnings: ['No atom mapping detected', 'Product InChI key could not be resolved'],
  },
  {
    item_id: 4,
    source_row: 4,
    status: 'INVALID',
    preview: { reactants: 0, products: 0, catalysts: 0, hasAtomMapping: false, yieldPercent: null, solvents: null, tempC: null, timeH: null },
    reaction_smiles: null,
    hash: null,
    atom_mapped_smiles: null,
    rxnfile: null,
    conditions: {},
    outcome: {},
    errors: ['Failed to parse RXN block: missing $RXN header', 'No reactants or products found'],
    warnings: [],
  },
  {
    item_id: 5,
    source_row: 5,
    status: 'VALID',
    preview: { reactants: 2, products: 1, catalysts: 1, hasAtomMapping: true, yieldPercent: 45, solvents: ['DCM'], tempC: 0, timeH: 1 },
    reaction_smiles: 'c1ccc2[nH]ccc2c1.ClC(=O)CCl>>c1ccc2c(c1)cc(CC(=O)Cl)[nH]2',
    hash: 'jkl012',
    atom_mapped_smiles: null,
    rxnfile: null,
    conditions: { solvents: ['DCM'], temperature_c: 0, time_h: 1 },
    outcome: { yield_percent: 45, yield_type: 'isolated' },
    errors: [],
    warnings: [],
  },
  {
    item_id: 6,
    source_row: 6,
    status: 'SKIPPED',
    preview: { reactants: 1, products: 1, catalysts: 0, hasAtomMapping: false, yieldPercent: null, solvents: null, tempC: null, timeH: null },
    reaction_smiles: 'C>>C',
    hash: 'mno345',
    atom_mapped_smiles: null,
    rxnfile: null,
    conditions: {},
    outcome: {},
    errors: [],
    warnings: ['Duplicate of row 1 (same hash)'],
  },
];
